import ProductStorage from './ProductStorage';
import type { Props } from './ProductStorage';

/**
 * @deprecated 請改用 ProductStorage
 */
interface OldProps<T> extends Omit<Props<T>, 'productData'> {
  /**
   * @deprecated 請用 productData
   */
  productSource: Props<T>['productData'];
}

/**
 * @deprecated 請改用 ProductStorage
 */
export default class ItemSource<T = any> extends ProductStorage<T> {
  constructor(props: OldProps<T>) {
    super({
      initialValue: props.initialValue,
      productKey: props.productKey,
      productData: props.productSource,
    });
  }

  /**
   * @deprecated 請改用 processData
   */
  processSource = this.processData;
}
